import { noop } from 'lodash/fp';
import { VFC } from 'react';

import { FlagIssuesFormData } from 'dashboard/forms/FormFlagIssues';
import { DocumentGeneric } from 'dashboard/models/document';
import { Inquiry } from 'dashboard/models/inquiry';
import { InquiryTemplate } from 'dashboard/models/inquiry-template';
import { InquiryTemplateVersion } from 'dashboard/models/inquiry-template-version';
import { Tag } from 'dashboard/models/tag';
import { Template } from 'dashboard/models/template';
import { Verification } from 'dashboard/models/verification';
import ResourceInquiry, { ResourceInquiryAttribute } from 'dashboard/modules/ResourceInquiry';
import { ApiModel } from 'lib/interfaces/api';

interface RelatedInquiriesProps {
  inquiries: Inquiry[];
  handleFlagInquiryIssues: (
    inquiry: Inquiry,
    verifications: Verification[],
    values: FlagIssuesFormData,
  ) => Promise<void>;
}

const RelatedInquiries: VFC<RelatedInquiriesProps> = ({ inquiries, handleFlagInquiryIssues }) => {
  return (
    <>
      {inquiries.map((inquiry) => {
        const templates =
          inquiry.relationships['inquiry-template'].data != null
            ? [inquiry.relationships['inquiry-template'].data as InquiryTemplate]
            : [inquiry.relationships.template.data as Template];
        const templateVersions =
          inquiry.relationships['inquiry-template-version'].data != null
            ? [inquiry.relationships['inquiry-template-version'].data as InquiryTemplateVersion]
            : [];
        const documents = inquiry.relationships.documents.data.filter(
          (d): d is DocumentGeneric => d.type === ApiModel.DocumentGeneric,
        );

        // We may want some configurations per inquiry template here in the future
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        const attributes: ResourceInquiryAttribute[] = [
          ResourceInquiryAttribute.Name,
          ResourceInquiryAttribute.GovernmentIDNumber,
          ResourceInquiryAttribute.ExpirationDate,
          ResourceInquiryAttribute.Address,
          inquiry.attributes.birthdate != null ? ResourceInquiryAttribute.BirthDate : null,
          inquiry.attributes['email-address'] != null
            ? ResourceInquiryAttribute.EmailAddress
            : null,
          inquiry.attributes['phone-number'] != null ? ResourceInquiryAttribute.PhoneNumber : null,
          inquiry.attributes['social-security-number'] != null
            ? ResourceInquiryAttribute.SocialSecurityNumber
            : null,
          documents.length > 0 ? ResourceInquiryAttribute.DocumentExtraction : null,
          ResourceInquiryAttribute.Fields,
        ].filter(Boolean);

        return (
          <ResourceInquiry
            key={inquiry.id}
            attributes={attributes}
            defaultAccordionOpen={false}
            documents={documents}
            featureFlags={{}}
            inquiry={inquiry}
            inquiryTemplates={templates}
            inquiryTemplateVersions={templateVersions}
            handleUpdateInquiryTags={noop}
            tags={inquiry.relationships.tags.data as Tag[]}
            verifications={inquiry.relationships.verifications.data as Verification[]}
            handleFlagInquiryIssues={handleFlagInquiryIssues}
          />
        );
      })}
    </>
  );
};

export default RelatedInquiries;
